module.exports = __webpack_public_path__ + "static/media/15-RotHeatExchanger - No cool - Water heat.6bc48631.png";